export const showSnackBar = (payLoad)  => dispatch => {
    dispatch({ type: 'SHOW_SNACK_BAR', payload: payLoad })
}
export const closeSnackBar = ()  => dispatch => {
    dispatch({ type: 'CLOSE_SNACK_BAR', payload: {} })
}